import styles from './styles'

export default styles;
